<template>
  <div>
    <modalSejaBemVindo></modalSejaBemVindo>
    <div class="fixed-top">
      <div class="menu">
        <nav
          class="nav-home navbar-menu d-flex align-items-center justify-content-between container"
        >
          <div class="navbar-left d-flex align-items-center d-none">
            <a class="navbar-brand" href="/">
              <img style="max-width: 120px;" :src="linkLogo" />
            </a>
          </div>

          <div class="navbar-center">
            <audio id="audio-coins" style="visibility: hidden;">
              <source
                :src="require('@/assets/audio-coins.mp3')"
                type="audio/mpeg"
                muted
              />
            </audio>
            <ul
              class="navbar-nav d-flex align-items-center justify-content-center"
            >
              <li class="nav-item">
                <a href="/">Início</a>
              </li>
              <li class="nav-item">
                <a href="/comoFunciona">Como Funciona</a>
              </li>
              <li class="nav-item">
                <a href="/Ajuda">Faq</a>
              </li>
              <li class="nav-item" v-if="!decoded">
                <a href="javascript:void(0)" @click="modalCadastrese = true"
                  >Cadastre-se</a
                >
              </li>
              <li class="nav-item">
                <a href="/dashboard" v-if="!decoded">Minha Conta</a>
              </li>
            </ul>
          </div>

          <div class="navbar-right d-flex align-items-center ">
            <div class="user-options d-flex align-items-center">
              <a
                to="javascript:void(0)"
                style="text-decoration: none;"
                class="mr-2"
                v-if="decoded"
              >
                <span> <b>Saldo:</b> {{ saldo | currency }}</span>
              </a>
              <button
                @click="modalSaldo = true"
                v-if="decoded"
                class="item-saldo"
              >
                <i class="ri-money-dollar-box-line"></i> Depositar
              </button>
              <button
                class="menu-person btn-degrade"
                v-if="!decoded"
                @click="modalLogin = true"
              >
                <i class="ri-account-circle-fill"></i>
                Entrar
              </button>
              <button
                class="btn-person btn-degrade"
                v-else
                @click="goTo('Dashboard')"
              >
                <i class="ri-account-circle-fill"></i>
                <span class="name-person">{{
                  getFirstName(decoded.nome)
                }}</span>
              </button>
            </div>
          </div>
        </nav>
      </div>

      <div class="container mb-4">
        <carrousel></carrousel>
      </div>
    </div>

    <MenuMobile
      v-if="isDetalheCaixa == false"
      :isDetalheCaixa="isDetalheCaixa"
    ></MenuMobile>

    <modal
      :show.sync="modalLogin"
      :show-close="true"
      body-classes="p-3 pb-5"
      modal-classes="modal-dialog-centered "
      close-classes="text-white"
      @close="fechaModais"
    >
      <slot name="header"
        ><h3 class="text-black text-white">Acesse sua Conta</h3>
      </slot>
      <div>
        <formLogin
          :insideBox="true"
          @login="finalizaBoxLogin"
          :insideModal="true"
        ></formLogin>
      </div>
    </modal>

    <modal
      :show.sync="modalCadastrese"
      :show-close="true"
      body-classes="p-3 pb-5"
      modal-classes="modal-dialog-centered "
      @close="fechaModais"
    >
      <slot name="header"><h3 class="text-black">Crie sua Conta</h3> </slot>
      <div>
        <formCadastro
          :insideBox="true"
          :insideLogin="true"
          @returnLogin="finalizaBoxLogin('voltar')"
          @CadastroConcluido="finalizaBoxLogin('Cadastro')"
        ></formCadastro>
      </div>
    </modal>

    <modal
      :show.sync="modalSaldo"
      :show-close="true"
      body-classes="p-3 pb-5"
      modal-classes="modal-dialog-centered "
      @close="fechaModais"
    >
      <slot name="header"
        ><h3 class="text-black text-white">Adicionar Créditos</h3>
      </slot>
      <div>
        <formSaldo
          :insideBox="true"
          @saldoAtualizado="fechaModais"
          @erroLogin="finalizaBoxLogin('voltar')"
          @CloseModal="fechaModais"
        ></formSaldo>
      </div>
    </modal>
  </div>
</template>

<script>
import { Card, Tabs, TabPane, Button, NavLink, Modal } from '@/components';
import { Carousel, Slide } from 'vue-carousel';
import service from './../services';
import jwt from 'jsonwebtoken';
import Avatar from 'vue-avatar';
import storage from './../services/storage';
import { KEY_LOCAL_STORAGE } from './../const';
import formLogin from './../pages/components_site/formLogin.vue';
import formCadastro from './../pages/components_site/formCadastro.vue';
import formSaldo from './../pages/components_site/formPagamentos.vue';
import boxesHome from '@/pages/v2/componentes/boxesHome.vue';
import carrousel from './../pages/v2/componentes/carrousel.vue';
import modalSejaBemVindo from './../pages/v2/componentes/modalSejaBemVindo.vue';
import MenuMobile from './menuMobile.vue';
import 'remixicon/fonts/remixicon.css';

export default {
  props: {
    isDetalheCaixa: Boolean,
  },
  data() {
    return {
      onlineCount: 0,
      tema: this.$funcoesTema.getTema(),
      linkLogo: this.retornaLinkLogo(),
      carregando: false,
      itens: [],
      modalLogin: false,
      modalCadastrese: false,
      modalSaldo: false,
      decoded: null,
      saldo: 0,
      myInterval: null,
      subscribed: null,
      modalCaixas: false,
      isDisabled: false,
    };
  },

  methods: {
    getFirstName(nome) {
      return nome.split(' ')[0];
    },
    retornaLinkLogo() {
      return process.env.VUE_APP_LOGO;
    },
    retornaQtd() {
      const qtd = storage.lerStorage('qtd-itens');
      if (qtd) {
        return qtd;
      } else return 0;
    },
    simularAbertura() {
      this.$emit('EventoToRoleta', {
        evento: 'Simular',
        aberturaRapida: this.aberturaRapida,
      });
    },
    getTema() {
      if (!this.tema) {
        this.tema = JSON.parse(localStorage.getItem('tema'));
      }
    },
    goTo(path) {
      this.$router.push('/' + path);
    },

    buscarDados() {
      const token = storage.lerStorage(KEY_LOCAL_STORAGE.USER_TOKEN);

      if (token) {
        this.decoded = jwt.decode(token);
      } else {
        this.decoded = null;
      }

      let saldo = storage.lerStorage(KEY_LOCAL_STORAGE.SALDO);
      if (saldo) {
        this.saldo = window.atob(saldo);
      }
    },
    playCoins() {
      document.getElementById('audio-coins').muted = false;
      document.getElementById('audio-coins').play();
    },
    buscarDadosBanco() {
      if (this.decoded) {
        service
          .getAll('Usuario', {}, 'BuscarSaldo')
          .then(res => {
            const s = storage.lerStorage(KEY_LOCAL_STORAGE.SALDO);
            storage.escreveStorage(KEY_LOCAL_STORAGE.SALDO, res.data.s);
            if (s != res.data.s) {
              // this.playCoins();
            }

            this.retornaQtd();
          })
          .catch(e => {
            console.error(e);
            storage.removeItem(KEY_LOCAL_STORAGE.USER_TOKEN);
          });
      }
    },
    verificaUid() {
      if (this.$route.query.uid) {
        storage.escreveStorage('uid', this.$route.query.uid);
      }
    },
    changeLocalStorage(key) {
      switch (key) {
        case KEY_LOCAL_STORAGE.SALDO:
        case KEY_LOCAL_STORAGE.USER_TOKEN:
          this.buscarDados();
          break;

        case KEY_LOCAL_STORAGE.QUANT_ITENS:
          this.retornaQtd();
      }
    },
    fechaModais() {
      this.modalLogin = false;
      this.modalCadastrese = false;
      this.modalSaldo = false;
    },
    finalizaBoxLogin(from) {
      this.fechaModais();
      if (from == 'Cadastro') this.modalSaldo = true;
      if (from == 'voltar') this.modalLogin = true;
    },
  },
  created() {
    this.verificaUid();
    this.subscribed = storage.subscribe(this.changeLocalStorage);
  },

  mounted() {
    this.buscarDados();
    this.buscarDadosBanco();
    this.getTema();
    this.onlineCount = Math.floor(Math.random() * (2500 - 1000 + 1)) + 1000;
  },
  beforeDestroy() {
    storage.unsubscribe(this.subscribed);
    clearInterval(this.myInterval);
  },
  components: {
    Card,
    Tabs,
    TabPane,
    [Button.name]: Button,
    Carousel,
    Slide,
    Avatar,
    formLogin,
    formCadastro,
    formSaldo,
    Modal,
    NavLink,
    carrousel,
    boxesHome,
    modalSejaBemVindo,
    MenuMobile,
  },
};
</script>

<style lang="scss">
.fixed-top {
  z-index: 90 !important;
}
.ao-vivo {
  background-color: #171a1b;
  margin-top: 70px;
  padding-top: 10px;
}

.navbar-brand:hover {
  background-color: transparent !important;
}

.menu {
  border-bottom: 1px solid rgb(50, 50, 50);
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .navbar-menu {
    .navbar-left {
      display: flex;
      align-items: center;

      .logo {
        max-width: 120px;
      }

      .live-person {
        display: flex;
        align-items: center;
        margin-left: 10px;

        .icon-online {
          font-size: 20px;
        }

        .text-online {
          color: #555a68;
          margin-left: 5px;

          h6 {
            font-size: 14px;
            margin-bottom: 0;
          }

          span {
            font-size: 12px;
            color: #aaa;
          }
        }
      }
    }

    .navbar-center {
      display: flex;
      align-items: center;

      .navbar-nav {
        display: flex;
        align-items: center;
        flex-direction: row;
        gap: 20px;

        .nav-item {
          a {
            font-size: 13px;
            text-decoration: none;
            font-weight: 700;
          }
        }
      }
    }

    .navbar-right {
      display: flex;
      align-items: center;

      .social-icons {
        display: flex;
        justify-content: center;
        align-items: center;

        .social-icon {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 20px;
          height: 20px;
          border-radius: 4px;
          background-color: #19191b;
          font-size: 12px;
          color: #5e5e5e;
          transition: background-color 0.3s;
          text-decoration: none;
          margin: 3px;

          &:hover {
            background-color: #555;
            color: #fff;
          }
        }
      }

      .user-options {
        display: flex;
        align-items: center;
        color: #fff;

        .btn-person {
          font-size: 14px;
          margin: 10px;
          border-radius: 8px;
          border: none;
          padding: 7px 10px;
          font-weight: bold;
        }

        .menu-person {
          font-size: 14px;
          margin: 10px;
          border-radius: 8px;
          border: none;
          padding: 7px 10px;
          font-weight: bold;
        }

        .user-name {
          font-size: 16px;
        }

        .user-avatar {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          margin-left: 15px;
        }
      }
    }
  }
}

.ultimasAberturas {
  text-align: center;
}

.sliderBox {
  padding: 5px;
  margin: 0.5rem;
  height: 80px;
}

.conteudo-slider {
  max-height: 150px;
}

.conteudo-imagens {
  margin-top: -15px;
}

.imgProduto,
.imgCaixa {
  max-height: 100px;
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.imgCaixa {
  opacity: 0;
}

.sliderBox:hover .imgProduto {
  transform: translateY(100%) scale(0);
  opacity: 0;
  transition: transform 0.3s ease, opacity 0s ease;
}

.sliderBox:hover .imgCaixa {
  opacity: 1;
  animation: grow-shrink 1s ease-in-out forwards;
}

.sliderBox:hover .avatarSwiper {
  transform: translateX(-10%) translateY(20%) scale(1.2);
}

.sliderValor {
  font-size: 10px;
  border: none;
}

.avatarSwiper {
  transition: transform 0.3s ease;
}

@media all and (min-width: 480px) {
  .navbar-center {
    display: none;
  }
}

@media all and (max-width: 479px) {
  .nav-home {
    padding: 6px;
  }

  .sliderBox {
    height: 100px;
  }

  .conteudo-slider {
    max-height: 100px;
  }

  .conteudo-imagens {
    margin-top: -25px;
    max-height: 70px;
  }
  .imgProduto,
  .imgCaixa {
    max-height: 70px;
  }
}

@media screen and (max-width: 768px) {
  .navbar-center {
    display: none !important;
  }

  nav .live-person {
    display: none !important;
  }

  nav .social-icons {
    display: none !important;
  }
}

@keyframes grow-shrink {
  0% {
    transform: translateY(0) scale(0);
  }
  20% {
    transform: translateY(-100%) scale(1);
  }
  40% {
    transform: translateY(-100%) scale(1.3);
  }
  60% {
    transform: translateY(-100%) scale(1);
  }
  80% {
    transform: translateY(-100%) scale(1.05);
  }
  100% {
    transform: translateY(-100%) scale(1);
  }
}

.mobile-menu {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: #202020;
  border-top: solid 3px rgb(47, 47, 47);
  padding: 10px 0;
  z-index: 1049;
  border-radius: 20px 20px 0px 0px;
  transition: opacity 0.5s ease-in-out; /* Transição para o efeito */
}

.mobile-menu.hidden {
  opacity: 0; /* Oculta o menu */
  pointer-events: none; /* Impede interação quando oculto */
}

.menu-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 12px;
  font-family: Arial, sans-serif;
  text-align: center;
  transition: transform 0.3s ease, color 0.3s ease;
}

.menu-button i {
  font-size: 24px;
  margin-bottom: 5px;
}

.btn-center {
  position: relative;
  top: -20px;
  width: 10vw;
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  overflow: visible;
}

.btn-center::before {
  content: '';
  position: absolute;
  top: -4px;
  left: -4px;
  width: calc(100% + 8px);
  height: calc(100% + 8px);
  background: linear-gradient(90deg, rgb(182, 175, 160) 0%, #ffffff);
  border-radius: 50%;
  z-index: -1;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes heartbeat {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

.btn-center:focus {
  transform: scale(1.2);
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.5);
}

.btn-center img {
  width: 35px;
  height: 35px;
}

@media (min-width: 600px) {
  .mobile-menu {
    display: none;
  }
}

@media (max-width: 600px) {
  .btn-center {
    width: 15vw;
  }
  .btn-person {
    display: none;
  }
}
</style>
